import { handleActions } from "redux-actions";
import {
    getInitialScrapeTasks,
    getInitialScrapeTasksSuccess,
    getInitialScrapeTasksError,
    setSelectedTasks,
    enableInitialScrapeTasksSuccess,
    setStartTasksDialog,
    mergeStartTasksDialog,
    setInitialScrapeTaskDialog,
    mergeInitialScrapeTaskDialog,
    mergeIntervalHoursTasksDialog,
    setIntervalHoursTasksDialog,
    setOneTimeSearchDialog,
    mergeOneTimeSearchDialog,
    setRescheduleDialog,
    setDeleteDialog,
    mergeRescheduleDialog,
    mergeDeleteDialog,
    clearInitialScrapeTasks,
    getCountSchedulerListSuccess,
    getCountSchedulerListError,
    getCountSchedulerList,
    setScheduleDialog,
    mergeScheduleDialog,
    setDownloadKeywordsDialog,
    mergeDownloadKeywordsDialog,
    setIntervalHoursAllTasksDialog,
    setPaginationLimitTasksDialog,
    setPaginationLimitAllTasksDialog,
    setProgressDialog,
    mergeProgressDialog,
    mergeEditMetadataDialog,
    setEditMetadataDialog
} from "modules/Scheduler/services/InitialScrapeTasks/actions";

const initialState = {
    isLoading: false,
    isLoadingCount: false,
    count: 0,
    ids: [],
    initialScrapeTasks: [],
    selectedInitialScrapeTasks: [],
    startTasksDialog: {
        isOpen: false,
        selected: [],
        isLoading: false,
        initialValues: {
            disable_cache: true,
            save_to_hot_storage: false
        }
    },
    editMetadataDialog: {
        isOpen: false,
        isLoading: false,
        ids: [],
        initialValues: {}
    },
    intervalHoursTasksDialog: {
        isOpen: false,
        isLoading: false
    },
    intervalHoursAllTasksDialog: {
        isOpen: false,
        isLoading: false
    },
    paginationLimitTasksDialog: {
        isOpen: false,
        isLoading: false
    },
    paginationLimitAllTasksDialog: {
        isOpen: false,
        isLoading: false
    },
    tasksDialog: {
        isOpen: false,
        isLoading: false,
        ids: [],
        initialValues: { run_every_n_hours: 24, enabled: true }
    },
    oneTimeSearchDialog: {
        isOpen: false,
        isLoading: false,
        isRescrape: false,
        initialValues: null
    },
    rescheduleDialog: {
        isOpen: false,
        isLoading: false,
        status: null
    },
    deleteDialog: {
        isOpen: false,
        isLoading: false,
        status: null
    },
    downloadDialog: {
        isOpen: false,
        isLoading: false,
        status: null,
        url: null
    },
    scheduleDialog: {
        isOpen: false,
        completionPercentage: 0
    },
    progressDialog: {
        isOpenProgress: false,
        isLoadingProgress: false,
        statusProgress: null
    },
};

export const initialScrapeTasksReducer = handleActions(
    {
        [clearInitialScrapeTasks]: () => ({ ...initialState }),
        [getInitialScrapeTasks]: (state) => ({
            ...state,
            ids: [],
            count: 0,
            initialScrapeTasks: [],
            selectedInitialScrapeTasks: [],
            isLoading: true
        }),
        [getInitialScrapeTasksSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getInitialScrapeTasksError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [setSelectedTasks]: (state, { payload }) => ({
            ...state,
            selectedInitialScrapeTasks: payload
        }),

        [enableInitialScrapeTasksSuccess]: (state) => ({
            ...state,
            selectedInitialScrapeTasks: []
        }),

        [setStartTasksDialog]: (state, { payload }) => ({
            ...state,
            startTasksDialog: {
                ...initialState.startTasksDialog,
                ...payload
            }
        }),
        [mergeStartTasksDialog]: (state, { payload }) => ({
            ...state,
            startTasksDialog: {
                ...state.startTasksDialog,
                ...payload
            }
        }),

        [setEditMetadataDialog]: (state, { payload }) => ({
            ...state,
            editMetadataDialog: {
                ...initialState.editMetadataDialog,
                ...payload
            }
        }),
        [mergeEditMetadataDialog]: (state, { payload }) => ({
            ...state,
            editMetadataDialog: {
                ...state.editMetadataDialog,
                ...payload
            }
        }),

        [setIntervalHoursTasksDialog]: ( state, { payload } ) => {
            return {
                ...state,
                intervalHoursTasksDialog: {
                    ...initialState.intervalHoursTasksDialog,
                    ...payload
                }
            };
        },

        [setIntervalHoursAllTasksDialog]: ( state, { payload } ) => {
            return {
                ...state,
                intervalHoursAllTasksDialog: {
                    ...initialState.intervalHoursAllTasksDialog,
                    ...payload
                }
            };
        },

        [setPaginationLimitTasksDialog]: ( state, { payload } ) => {
            return {
                ...state,
                paginationLimitTasksDialog: {
                    ...initialState.paginationLimitTasksDialog,
                    ...payload
                }
            };
        },

        [setPaginationLimitAllTasksDialog]: ( state, { payload } ) => {
            return {
                ...state,
                paginationLimitAllTasksDialog: {
                    ...initialState.paginationLimitAllTasksDialog,
                    ...payload
                }
            };
        },
        [mergeIntervalHoursTasksDialog]: ( state, { payload } ) => {
            return {
                ...state,
                intervalHoursTasksDialog: {
                    ...state.intervalHoursTasksDialog,
                    ...payload
                }
            };
        },

        [setInitialScrapeTaskDialog]: (state, { payload }) => ({
            ...state,
            tasksDialog: {
                ...initialState.tasksDialog,
                ...payload
            }
        }),
        [mergeInitialScrapeTaskDialog]: (state, { payload }) => ({
            ...state,
            createTasksDialog: {
                ...state.createTasksDialog,
                ...payload
            }
        }),

        [setOneTimeSearchDialog]: (state, { payload }) => ({
            ...state,
            oneTimeSearchDialog: {
                ...initialState.oneTimeSearchDialog,
                ...payload
            }
        }),
        [mergeOneTimeSearchDialog]: (state, { payload }) => ({
            ...state,
            oneTimeSearchDialog: {
                ...state.oneTimeSearchDialog,
                ...payload
            }
        }),

        [getCountSchedulerList]: (state) => ({
            ...state,
            isLoadingCount: true
        }),
        [getCountSchedulerListSuccess]: (state, { payload }) => ({
            ...state,
            count: payload,
            isLoadingCount: false
        }),
        [getCountSchedulerListError]: (state) => ({
            ...state,
            isLoadingCount: false
        }),

        [setRescheduleDialog]: (state, { payload }) => ({
            ...state,
            rescheduleDialog: {
                ...initialState.rescheduleDialog,
                ...payload
            }
        }),
        [mergeRescheduleDialog]: (state, { payload }) => ({
            ...state,
            rescheduleDialog: {
                ...state.rescheduleDialog,
                ...payload
            }
        }),
        [setProgressDialog]: (state, { payload }) => ({
            ...state,
            progressDialog: {
                ...initialState.progressDialog,
                ...payload
            }
        }),
        [mergeProgressDialog]: (state, { payload }) => ({
            ...state,
            progressDialog: {
                ...state.progressDialog,
                ...payload
            }
        }),

        [setDeleteDialog]: (state, { payload }) => ({
            ...state,
            deleteDialog: {
                ...initialState.deleteDialog,
                ...payload
            }
        }),
        [mergeDeleteDialog]: (state, { payload }) => ({
            ...state,
            deleteDialog: {
                ...state.deleteDialog,
                ...payload
            }
        }),

        [setScheduleDialog]: (state, { payload }) => ({
            ...state,
            scheduleDialog: {
                ...initialState.scheduleDialog,
                ...payload
            }
        }),
        [mergeScheduleDialog]: (state, { payload }) => ({
            ...state,
            scheduleDialog: {
                ...state.scheduleDialog,
                ...payload
            }
        }),

        [setDownloadKeywordsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...initialState.downloadDialog,
                ...payload
            }
        }),
        [mergeDownloadKeywordsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...state.downloadDialog,
                ...payload
            }
        })
    },
    initialState
);
